import React, { useState } from 'react';
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { FileText, Save } from 'lucide-react';

export default function LegalDocumentEditor({ document, onSave }) {
  const [editedDoc, setEditedDoc] = useState(document || {
    title: '',
    slug: '',
    content: '',
    last_updated: new Date().toISOString().split('T')[0],
    version: '1.0'
  });

  const handleSave = () => {
    onSave(editedDoc);
  };

  return (
    <Card className="p-6">
      <div className="flex items-center gap-2 mb-4">
        <FileText className="w-5 h-5 text-emerald-600" />
        <h3 className="font-semibold text-gray-900">
          {document ? 'Editar Documento' : 'Nuevo Documento'}
        </h3>
      </div>

      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Título
          </label>
          <Input
            value={editedDoc.title}
            onChange={(e) => setEditedDoc({ ...editedDoc, title: e.target.value })}
            placeholder="Ej: Términos y Condiciones"
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Slug (identificador único)
          </label>
          <Input
            value={editedDoc.slug}
            onChange={(e) => setEditedDoc({ ...editedDoc, slug: e.target.value })}
            placeholder="Ej: terms, privacy"
            disabled={!!document}
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Versión
          </label>
          <Input
            value={editedDoc.version}
            onChange={(e) => setEditedDoc({ ...editedDoc, version: e.target.value })}
            placeholder="Ej: 1.0"
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Fecha de última actualización
          </label>
          <Input
            type="date"
            value={editedDoc.last_updated}
            onChange={(e) => setEditedDoc({ ...editedDoc, last_updated: e.target.value })}
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 block mb-2">
            Contenido
          </label>
          <Textarea
            value={editedDoc.content}
            onChange={(e) => setEditedDoc({ ...editedDoc, content: e.target.value })}
            className="h-96 font-mono text-sm"
            placeholder="Contenido completo del documento legal..."
          />
        </div>

        <Button onClick={handleSave} className="w-full">
          <Save className="w-4 h-4 mr-2" />
          Guardar Documento
        </Button>
      </div>
    </Card>
  );
}